import React from 'react';
import { Card, Typography, View } from '@usepepper/sprout-kit-ui';
import { InvoiceSummaryAmountSize } from '@finance-hub/domain/invoicing/blocs/utils/invoice-summary-amount-size-utils';

const CARD_HOVER_STYLE = { backgroundColor: '$bgSecondaryDefault' } as const;
const CARD_PRESS_STYLE = { opacity: 0.9 } as const;

export type BucketInteractionState = 'active' | 'inactive';

export interface BucketCardColors {
  activeBorderColor: string;
  backgroundColor: string;
  borderColor: string;
  countColor: string;
  labelColor: string;
  textColor: string;
}

interface InvoiceSummaryBucketCardBaseProps {
  amount: string;
  amountSize: InvoiceSummaryAmountSize;
  colors: BucketCardColors;
  countLabel: string;
  interactionState: BucketInteractionState;
  label: string;
  minWidth: number;
  onPress: () => void;
}

export const InvoiceSummaryBucketCardBase: React.FC<
  InvoiceSummaryBucketCardBaseProps
> = ({
  amount,
  amountSize,
  countLabel,
  interactionState,
  label,
  minWidth,
  onPress,
  colors,
}) => {
  const isActive = interactionState === 'active';

  return (
    <View
      accessibilityLabel={`${amount} ${label}, ${countLabel}`}
      accessibilityRole="button"
      accessibilityState={{ selected: isActive }}
      accessible
      backgroundColor={colors.backgroundColor}
      borderColor={isActive ? colors.activeBorderColor : colors.borderColor}
      borderRadius="$12"
      borderWidth={isActive ? 2 : 1}
      cursor="pointer"
      flexBasis={minWidth}
      flexGrow={1}
      flexShrink={1}
      hoverStyle={CARD_HOVER_STYLE}
      minWidth={minWidth}
      onPress={onPress}
      overflow="hidden"
      pressStyle={CARD_PRESS_STYLE}
    >
      <Card
        alignItems="flex-start"
        backgroundColor="$transparent"
        borderWidth={0}
        //  `flex={1}` here leaves the card zero-height on mobile, hiding the text
        flexBasis="auto"
        flexGrow={1}
        gap="$4"
        paddingHorizontal="$16"
        paddingVertical="$12"
      >
        <Typography
          bold
          color={colors.labelColor}
          size="$2xs"
          textTransform="uppercase"
        >
          {label}
        </Typography>
        <Typography
          bold
          color={colors.textColor}
          numberOfLines={1}
          size={amountSize}
          variant="heading"
        >
          {amount}
        </Typography>
        <Typography color={colors.countColor} fontWeight="$medium" size="$xs">
          {countLabel}
        </Typography>
      </Card>
    </View>
  );
};
